import React from "react";
import { useNavigate } from "react-router-dom";
import logo from '../leclab-madrid-vertical.png'
import { logout } from "../services/firebase/firebase";

const AdminHeader = ({ setContent }) => {

    const navigate = useNavigate()

    const doLogout = (e) => {
        e.preventDefault()
        logout()
        navigate('/')
    }

    return (
        <header className="p-3 bg-dark text-white sticky-top">
            <div className="container">
                <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
                    <a href="/" className="d-flex align-items-center mb-2 mx-2 mb-lg-0 text-white text-decoration-none">
                        <img src={logo} width={50} className="rounded bg-white p-1" />
                    </a>

                    <ul className="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0">
                        <li><a className="nav-link px-2 text-white" style={{ cursor: 'pointer' }} onClick={() => setContent('socios')}>Socios</a></li>
                        <li><a className="nav-link px-2 text-white" style={{ cursor: 'pointer' }} onClick={() => setContent('invitaciones')}>Invitaciones</a></li>
                        <li><a className="nav-link px-2 text-white" style={{ cursor: 'pointer' }} onClick={() => setContent('solicitudes')}>Solicitudes</a></li>
                        <li><a className="nav-link px-2 text-white" style={{ cursor: 'pointer' }} onClick={() => setContent('eventos')}>Eventos</a></li>
                        <li><a className="nav-link px-2 text-white" style={{ cursor: 'pointer' }} onClick={() => setContent('promociones')}>Promociones</a></li>
                    </ul>

                    <div className="text-end">
                        <button type="button" className="btn btn-outline-light me-2" onClick={() => navigate('/user')}>Ir a modo usuario</button>
                        <button type="button" className="btn btn-warning" onClick={doLogout}>Logout</button>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default AdminHeader